import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { useAccount } from "#/store/wallet/account/account";

interface MintActivity {
  [account: string]: number;
}

export const mintActivityAtom = atomWithStorage<MintActivity>(
  "mintActivity",
  {},
);

export const useMintActivity = () => {
  const { account } = useAccount();
  const [mintActivity, setMintActivity] = useAtom(mintActivityAtom);

  const lastMintedAt = account ? (mintActivity[account] ?? 0) : 0;

  const recordMint = () => {
    if (!account) return;

    setMintActivity((prev) => ({
      ...prev,
      [account]: Date.now(),
    }));
  };

  return { lastMintedAt, recordMint };
};
